import type {
    RespondCommerceCheckoutUpsellRequest,
    RespondCommerceCheckoutUpsellResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const respondCommerceCheckoutUpsellOperation = defineCommerceOperation<
    RespondCommerceCheckoutUpsellRequest,
    RespondCommerceCheckoutUpsellResponse
>("commerce.checkout.upsell.respond");
